import { render, staticRenderFns } from "./DiagramSwitchSec.vue?vue&type=template&id=2b94fb50"
import script from "./DiagramSwitchSec.vue?vue&type=script&lang=js"
export * from "./DiagramSwitchSec.vue?vue&type=script&lang=js"
import style0 from "./DiagramSwitchSec.vue?vue&type=style&index=0&id=2b94fb50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports